import { PureComponent } from "react";
import classNames from "classnames";
import componentStyles from "./two-columns-with-carousel-component.scss";
import Picture from "/components/core/picture/picture-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import ButtonLinkComponent from "/components/core/button-link/button-link-component";
import colors from "/styles/colors";
import { convertToArrayIfNeeded } from "utils/arrays";

const DEFAULT_HOTDOG_COLOR = "brand-purple";

export default class TwoColumnsWithCarouselComponent extends PureComponent {
  renderParagraphs(paragraphs, disableHtmlSupport) {
    if (disableHtmlSupport) {
      if (paragraphs.length == 1 && paragraphs[0]) {
        paragraphs = paragraphs[0].split("\n");
      }
      return paragraphs.map((paragraph, index) => <div key={index}>{paragraph}</div>);
    }
    return paragraphs.map((paragraph, index) => <div key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />);
  }

  renderList(bullets, disableHtmlSupport) {
    if (disableHtmlSupport) {
      return (
        <ul className="content-list">
          {bullets.map((bullet, index) => (
            <li key={index}>{bullet}</li>
          ))}
        </ul>
      );
    }
    return (
      <ul className="content-list">
        {bullets.map((bullet, index) => (
          <li key={index} dangerouslySetInnerHTML={{ __html: bullet }} />
        ))}
      </ul>
    );
  }

  renderButtonLink() {
    const { text, href, color, openInNewTab } = this.props.content.buttonLink;
    const target = openInNewTab ? "_blank" : undefined;

    return (
      <div className="button-link-wrapper">
        <ButtonLinkComponent color={color} href={href} target={target}>
          {text}
        </ButtonLinkComponent>
      </div>
    );
  }

  renderAsset() {
    const { shadow, image, youtube } = this.props.asset;
    if (!image && !youtube) return undefined;

    if (image) {
      const pictureClassName = `main-image ${image.roundImage ? "round" : ""}`;
      const style = image.specificAssetStyle ? image.specificAssetStyle : { width: `${image.widthPercentage}%` };
      return (
        <div className="asset-inner" style={style}>
          <Picture className={pictureClassName} {...image} />
        </div>
      );
    } else if (youtube) {
      return (
        <div className="asset-inner" style={{ width: `${youtube.widthPercentage}%` }}>
          <iframe frameBorder={0} src={youtube.src} style={{ height: `${youtube.height}px` }} />
        </div>
      );
    } else {
      return undefined;
    }
  }

  render() {
    let { assetSide, signupForm, content, hotDog, asset, hideIfNoContent } = this.props;
    let { title: contentTitle, body: contentBody, contentType, buttonLink, disableHtmlSupport } = content;
    let { shadow, image } = asset;
    const withSignupForm = signupForm && signupForm.enabled;
    contentBody = convertToArrayIfNeeded(contentBody);

    if (hideIfNoContent && (contentBody.length == 0 || !contentBody[0])) {
      return <div />;
    }

    return (
      <div
        className={classNames("two-columns-with-carousel", {
          "asset-left": assetSide == "left",
          "with-signup": withSignupForm
        })}
      >
        <div className="top-line">
          <div className="content-column">
            <div className="content-inner">
              {!disableHtmlSupport && (
                <h2 className="content-title" dangerouslySetInnerHTML={{ __html: contentTitle }} />
              )}
              {disableHtmlSupport && <h2 className="content-title bold">{contentTitle}</h2>}
              <div className="content-body">
                {contentType === "list"
                  ? this.renderList(contentBody, disableHtmlSupport)
                  : this.renderParagraphs(contentBody, disableHtmlSupport)}
              </div>

              {buttonLink && this.renderButtonLink()}
            </div>
          </div>
          <div className={classNames("asset-column", { "with-shadow": shadow })}>
            {hotDog && (
              <div className="hot-dog" style={{ background: colors[hotDog.color] || colors[DEFAULT_HOTDOG_COLOR] }} />
            )}
            {this.renderAsset()}
          </div>
        </div>
        {withSignupForm && (
          <div className="bottom-line">
            <div className="signup-wrapper">
              {signupForm.title && <div className="signup-title">{signupForm.title}</div>}
              <SignupFormComponent />
            </div>
          </div>
        )}
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

TwoColumnsWithCarouselComponent.defaultProps = {
  content: {},
  asset: {},
  hotDog: {
    color: DEFAULT_HOTDOG_COLOR
  },
  hideIfNoContent: false
};
